module.exports = __webpack_public_path__ + "media/images/flags/CU-db17f8fc42cae70af1ca3f20917caad7.svg";